module.exports = __webpack_public_path__ + "static/media/Artboard 1 copy 123.b7101b5e.png";